import DeleteFolderAction from './DeleteFolderAction';

export default DeleteFolderAction;
